import { Component, OnInit, inject } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleetwide-user-logins",
	templateUrl: "./fleetwide-user-logins.component.html",
	styleUrls: ["./fleetwide-user-logins.component.scss"]
})
export class FleetwideUserLoginsComponent implements OnInit {
	api = inject(ApiService);

	public users: APIResults.UserLoginCounts[];

	async ngOnInit() {
		await this.updateUsers();
	}

	async updateUsers() {
		const result = await this.api.GetUserLogins();
		this.users = result;
	}

	async SortBy(field: string) {
		this.users.sort((a, b) => {
			return b[field] - a[field];
		});
	}
}
